var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHandTool = function SvgHandTool(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14H13V14.5C13 14.7761 13.2239 15 13.5 15C13.7761 15 14 14.7761 14 14.5V14H17V14.5C17 14.7761 17.2239 15 17.5 15C17.7761 15 18 14.7761 18 14.5V14H20C20.5523 14 21 14.4477 21 15V15.5C21 15.7761 21.2239 16 21.5 16C21.7761 16 22 15.7761 22 15.5V15C22 14.4477 22.4477 14 23 14H25C25 22 23 27 17 27C16.0712 27 15.6067 27 15.2168 26.9487C12.5244 26.5942 10.4058 24.4756 10.0513 21.7832C10 21.3933 10 20.9288 10 20V14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10C22 9.17157 22.6716 8.5 23.5 8.5C24.3284 8.5 25 9.17157 25 10V15.5C25 16.3284 24.3284 17 23.5 17C22.6716 17 22 16.3284 22 15.5V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7C18 6.17157 18.6716 5.5 19.5 5.5C20.3284 5.5 21 6.17157 21 7V15.5C21 16.3284 20.3284 17 19.5 17C18.6716 17 18 16.3284 18 15.5V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5C14 5.67157 14.6716 5 15.5 5C16.3284 5 17 5.67157 17 6.5V15.5C17 16.3284 16.3284 17 15.5 17C14.6716 17 14 16.3284 14 15.5V6.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V15.5C13 16.3284 12.3284 17 11.5 17C10.6716 17 10 16.3284 10 15.5V8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0002 15.0001C9.50018 17.5 10.5002 25 15.4289 25.4",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHandTool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "hand-tool.bb05f6b4cad69be4a6d7c058f2dbfeb9.svg";